import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../api/customCards';
import { addShopifyCard, addShopifyCardFailed, addShopifyCardSucceeded, editShopifyCard, editShopifyCardFailed, editShopifyCardSucceeded, getShopifyCardById, getShopifyCardByIdFailed, getShopifyCardByIdSucceeded, getShopifyCards, getShopifyCardsFailed, getShopifyCardsSucceeded, removeShopifyCard, removeShopifyCardFailed, removeShopifyCardSucceeded, testShopifyCard, testShopifyCardFailed, testShopifyCardSucceeded, } from '../reducers/sections/shopifyCards';
export const shopifyCards = [
    takeLatest(getShopifyCardById.toString(), genWithPromise(api.getCustomCardById, getShopifyCardByIdSucceeded, getShopifyCardByIdFailed)),
    takeLatest(getShopifyCards.toString(), genWithPromise(api.getCustomCards, getShopifyCardsSucceeded, getShopifyCardsFailed)),
    takeLatest(testShopifyCard.toString(), genWithPromise(api.testCustomCard, testShopifyCardSucceeded, testShopifyCardFailed)),
    takeLatest(editShopifyCard.toString(), genWithPromise(api.editCustomCard, editShopifyCardSucceeded, editShopifyCardFailed)),
    takeLatest(removeShopifyCard.toString(), genWithPromise(api.removeCustomCard, removeShopifyCardSucceeded, removeShopifyCardFailed)),
    takeLatest(addShopifyCard.toString(), genWithPromise(api.addCustomCard, addShopifyCardSucceeded, addShopifyCardFailed)),
];
function genWithPromise(apiAction, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        try {
            result = yield call(apiAction, action.payload);
            yield call(action.meta.resolve, result);
            yield put(resultSucceededAction(result));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            result = exception;
            yield put(resultFailedAction(result));
        }
    };
}
